/**
 * Onix Cart — Promo suggest popup + auto-downgrade + bundle auto-apply
 * ────────────────────────────────────────────────────────────────────
 * Drives #onix-promo-suggest in the cart drawer footer.
 *
 * Behaviour:
 *   - Bundle items added to cart → oniix discount code auto-applied in
 *     the background (no UI flash). Removed automatically when the last
 *     bundle item leaves the cart.
 *   - User adds maillots (bundle or not) → popup proposes the highest
 *     unlocked tier code (user decides whether to apply).
 *   - User clicks Apply → tier code stacks WITH oniix if bundle present,
 *     replaces any previous tier code otherwise.
 *   - User reduces maillots BELOW the min_qty of the currently applied
 *     code → AUTO downgrade to the code of the now-reached tier
 *     (or auto-clear if no tier reached). User does NOT need to act.
 *
 * Hidden when:
 *   - Below first tier qty
 *   - The currently applied tier already matches the highest reached
 *
 * Stackability rules (from Shopify combinesWith config):
 *   - oniix         (Bxgy) ⇄ tier codes ✓ stackable
 *   - tier codes    (Basic) ⇄ each other (only one tier active at a
 *                              time, popup auto-upgrades)
 *
 * Pulls shared helpers from window.OnixCart (cart-drawer-utils.js).
 * Load order: utils → cart-drawer → quickadd → discount → this
 */
(function () {
  const OnixCart = window.OnixCart || {};
  const loggedFetch = OnixCart.loggedFetch || fetch.bind(window);
  var LROOT=(window.OnixCart&&window.OnixCart.cartRoot)||(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/'; if(LROOT.slice(-1)!=='/')LROOT+='/';

  function init() {
    const root = document.getElementById('onix-promo-suggest');
    if (!root) return;

    let tiers;
    try {
      tiers = JSON.parse(root.dataset.tiers || '[]');
    } catch (e) {
      console.warn('[onix-promo-suggest] invalid tiers JSON', e);
      return;
    }
    if (!tiers.length) return;

    /* Sort tiers ascending by qty so we always find the highest reached. */
    tiers.sort((a, b) => a.qty - b.qty);

    const applyTxt = root.dataset.tApply || 'Appliquer';
    const msgEl = document.getElementById('onix-promo-suggest-msg');
    const applyBtn = document.getElementById('onix-promo-suggest-apply');
    /* ⚠️ LE VERBE A SON PROPRE ÉLÉMENT — B4, 19/08. La bande entière est
       devenue le bouton ; y écrire « … » avec un textContent effacerait le
       montant du même coup. Le montant vit dans msgEl, le verbe ici. */
    const verbeEl = document.getElementById('onix-promo-suggest-verbe');

    /* ⚠️ `escapeHtml` EST PARTI AVEC LE BANDEAU — 05/09. Il n'existait que pour
       les `innerHTML` du message de progression, retirés le même jour avec le
       reste du code mort. La jauge écrit en `textContent` : il n'y a plus une
       seule interpolation HTML dans ce fichier, donc plus rien à échapper.
       ➜ Si un jour on réécrit du HTML ici, on le remet — on n'échappe pas « à
         la main » et on ne concatène pas dans un `innerHTML` sans lui. */
    /* ⚠️ NE PAS REMETTRE {{code}} DANS LE MESSAGE. Le remplacement est gardé
       pour ne rien casser si un vieux libellé traîne, mais le code de palier
       ne se montre pas au client — règle du 02/08 : il n'apprend rien et
       invite à chercher un « meilleur » code ailleurs. */

    function findReachedTier(count) {
      let reached = null;
      for (const t of tiers) {
        if (count >= t.qty) reached = t;
      }
      return reached;
    }

    /* Code « roue de la fortune » ENCORE VALIDE. Il prime sur tout : le client
       l'a gagné, il est souvent plus avantageux qu'un palier, et l'écraser lui
       coûterait de l'argent (vécu en test : K7XR9M −20% remplacé par onix3
       −15% = 2,50 € perdus sur un panier à 2 maillots).
       On teste l'EXPIRATION : un code périmé est un code mort, il ne doit plus
       rien bloquer (cf. le bug de proposition disparue du 2026-08-02). */
    function wheelCodeActive() {
      try {
        const code = localStorage.getItem('onix_wheel_code_v3');
        if (!code) return false;
        const exp = parseInt(localStorage.getItem('onix_wheel_exp_v3'), 10);
        return !exp || Date.now() < exp;
      } catch (e) { return false; }
    }

    /* Palier RÉCLAMÉ par le client au popup newsletter (bouton « Appliquer »).
       Retourne le tier correspondant, ou null. On résout par le code plutôt
       que par le `min` stocké : si un palier change de seuil côté admin, on
       suit la config courante au lieu d'une valeur figée dans le navigateur. */
    function readPopupTier() {
      try {
        const code = localStorage.getItem('onix_popup_code');
        if (!code) return null;
        return tiers.find(t => t.code.toUpperCase() === code.toUpperCase()) || null;
      } catch (e) { return null; }
    }

    function findOurAppliedTier(cart) {
      const applied = [];
      /* Active discount applications (currently reducing the cart). */
      (cart.cart_level_discount_applications || []).forEach(a => { if (a.title) applied.push(a.title.toUpperCase()); });
      (cart.items || []).forEach(i => (i.discounts || []).forEach(d => { if (d.title) applied.push(d.title.toUpperCase()); }));
      /* Session discount codes — a code can sit in the session and not
         apply (e.g. min_qty no longer met after a quantity decrease).
         We treat a session code as "applied" so the auto-downgrade
         logic kicks in and replaces it instead of leaving a stale
         non-applying code in the user's cart. */
      (cart.discount_codes || []).forEach(d => { if (d.code) applied.push(d.code.toUpperCase()); });
      for (const t of tiers) {
        if (applied.includes(t.code.toUpperCase())) return t;
      }
      return null;
    }

    /* ── LES LIBELLÉS TRADUITS DE LA JAUGE ────────────────────────────
       `#onix-cart-progress` est un conteneur VIDE et `display: none` depuis le
       18/08 : il ne porte plus ni message, ni compteur, ni barre. Il ne sert
       qu'à une chose, et elle vaut la peine — porter les `data-t-*` écrits par
       Liquid, donc traduits dans les six langues. `dataset` se lit très bien
       sur un élément non affiché.
       ⚠️ `progMsg`, `progSav` et `progFill` ONT DISPARU AVEC LEUR CODE — 05/09.
         Les trois valaient `null` depuis le 18/08 et alimentaient cinquante
         lignes mortes, dont un second calcul du prix marginal.
       ⛔ `progStr` N'EST PLUS JAMAIS `null`, ET CE N'EST PAS COSMÉTIQUE. La
         jauge du pied le lit à chaque rendu : si le conteneur du haut venait à
         disparaître du balisage, l'ancienne écriture (`progEl ? {…} : null`)
         faisait lever « Cannot read properties of null » DANS le tiroir, et la
         jauge cessait de se mettre à jour — pour un élément invisible qui n'a
         rien à voir avec elle. Les défauts sont les mêmes qu'avant. */
    const progEl = document.getElementById('onix-cart-progress');
    const dsProg = (progEl && progEl.dataset) || {};
    const progStr = {
      remaining:  dsProg.tRemaining  || 'Ajoute {{n}} {{item}} pour {{price}} 🔥',
      item:       dsProg.tItem       || 'maillot',
      itemPlural: dsProg.tItemPlural || 'maillots',
      max:        dsProg.tMax        || '🎉',
      savings:    dsProg.tSavings    || 'Tu économises déjà {{amount}}',
    };

    /* Currency formatter mirroring cart-drawer.js: EUR → "12,34€",
       other presentment currencies → Intl narrowSymbol (matches `| money`). */
    const _drRoot = document.querySelector('[data-cart-drawer-root]');
    const CUR = (_drRoot && _drRoot.dataset.cartCurrency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const SHOP_RATE = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1) || 1;
    function fmtMoney(cents) {
      const a = (cents || 0) / 100;
      if (CUR === 'EUR') return a.toFixed(2).replace('.', ',') + '€';
      try { return new Intl.NumberFormat('en', { style: 'currency', currency: CUR, currencyDisplay: 'narrowSymbol' }).format(a); }
      catch (e) { try { return new Intl.NumberFormat('en', { style: 'currency', currency: CUR }).format(a); } catch (e2) { return a.toFixed(2) + ' ' + CUR; } }
    }
    /* "-20%" → {pct:0.2} ; "-30€"/"-44,98€" → {eurCents:3000/4498} (EUR, the
       shop currency — converted to the presentment currency via SHOP_RATE). */
    function parseTier(tier) {
      /* ⚠️ `tier.pct` D'ABORD — 03/09, même raison que dans cart-drawer.js :
         l'étiquette « -25€ » est un arrondi marketing, le vrai taux est 25 %.
         Sans ça l'échelle et la jauge annonçaient une remise fixe. */
      if (tier && tier.pct != null && tier.pct !== '') {
        const n = Number(tier.pct);
        if (Number.isFinite(n) && n > 0) return { pct: n > 1 ? n / 100 : n };
      }
      const s = String((tier && tier.label) || '').replace(/[−–-]/g, '').trim();
      if (s.indexOf('%') !== -1) return { pct: parseFloat(s) / 100 };
      const num = parseFloat(s.replace(/[^0-9.,]/g, '').replace(',', '.'));
      return { eurCents: Math.round((num || 0) * 100) };
    }

    /* ⚠️ `gainEnCentimes` RESTE, ET IL N'EST PLUS À L'ÉCHELLE. Il servait aux
       cinq colonnes retirées le 05/09 ET à la bande « Appliquer -14,99€ », qui
       elle est toujours là (`appliquerPalierAtteint`, plus bas). Le retirer
       aurait éteint le montant de la bande, en silence.
       ⚠️ LA REMISE EN EUROS D'UN PALIER EN % DÉPEND DU PANIER : « -15 % » vaut
         7,49 € sur des maillots à 24,99 € et autre chose dès qu'un article a un
         autre prix. On projette le prix unitaire sur la quantité du palier.
       ⚠️ `Math.floor` et pas `Math.round` : Shopify TRONQUE les remises en % au
         centime inférieur. 15 % de 49,98 € = 7,49 €, pas 7,50 €. */
    function gainEnCentimes(tier, uniteCents) {
      const p = parseTier(tier);
      return p.pct != null
        ? Math.floor(p.pct * uniteCents * tier.qty)
        : Math.round((p.eurCents || 0) * SHOP_RATE);
    }


    /* ⛔ LE PANIER MIXTE — DÉFAUT EN PRODUCTION, corrigé le 05/09.
       `baseCents / count` est une MOYENNE : juste sur un panier homogène, fausse
       dès qu'il ne l'est plus. 1 veste 59,99 € + 1 maillot 24,99 € donnaient
       « Ajoute 1 maillot pour 29,74 € » — AU-DESSUS du prix catalogue du maillot
       (24,99 €). Le vrai prix est 15,74 €. [M] 34 paniers sur 140 (≥ 2 articles,
       22/08→05/09) mélangent des prix unitaires : ce n'est pas un cas de bord.
       ⛔ ET CETTE FONCTION A MANQUÉ 40 MINUTES. Mon premier correctif a levé au
         milieu de son propre script : les appels sont partis, la définition non.
         La console de production disait « uniteMinPanier is not defined » et la
         jauge ne se mettait plus à jour — vu seulement en OUVRANT la page.
       ⚠️ Rend `null`, jamais 0 : un 0 ferait retomber sur la moyenne sans le dire.
       ⚠️ Les lignes de l'offre découverte sont exclues — leur prix à l'unité
         n'est pas un prix de catalogue. */
    function uniteMinPanier(items) {
      let min = null;
      (items || []).forEach(i => {
        if (!i) return;
        if (i.properties && i.properties._offer_bundle === 'true') return;
        let u = i.original_price;
        if (!(u > 0)) u = i.final_price;
        if (!(u > 0)) u = i.price;
        if (u > 0 && (min === null || u < min)) min = u;
      });
      return min;
    }

    /* ═══════════════════════════════════════════════════════════════════
       LA JAUGE DU DESIGN B — anneau + UN montant en euros.  05/09
       ═══════════════════════════════════════════════════════════════════
       Elle REMPLACE l'échelle des cinq paliers (« -7,49€ … -69,72€ »), sur sa
       remarque du 05/09, capture à l'appui. Il avait choisi le design B le
       même jour à 11h24 : « le desing b je trouve c'est le plus engageant ».

       ⛔ AUCUNE FORMULE N'EST ÉCRITE ICI. Zéro. Les cinq viennent des deux
         noyaux déjà en place, et c'est la seule chose qui garantit que le
         tiroir et la carte ne diront jamais deux montants différents :
           · `OnixBarreC.prixMarginalCentimes(tiers, count, base, taux, unite)`
           · `OnixBarreC.palierAtteint` · `OnixBarreC.gainCentimes`
           · `OnixCarteB.forme` · `OnixCarteB.fraction` · `OnixCarteB.composer`
         C'est écrit noir sur blanc en tête de onix-barre-c.js depuis le 05/09 :
         « si C est retenu, ces fonctions doivent DESCENDRE dans un module
         partagé et promo-suggest doit l'importer ; deux formules pour la même
         chose finissent par diverger d'un centime ». C'est fait ici.

       ⛔ LE 5ᵉ ARGUMENT — LE PANIER MIXTE, DÉFAUT DE PRODUCTION DU 05/09.
         Sans `uniteCents`, le noyau retombe sur la moyenne `base / count` :
         1 veste 59,99 € + 1 maillot 24,99 € annonçaient « Ajoute 1 maillot pour
         29,74 € », au-dessus du prix catalogue du maillot. Le vrai prix est
         15,74 €. [M] 34 paniers sur 140 (≥ 2 articles, 22/08→05/09) mélangent
         des prix unitaires.
       ⛔ ET L'APPEL OPTIMISTE NE PASSE PAS CE 5ᵉ ARGUMENT — cart-drawer.js
         l.1883 appelle `window.__onixPromoGauge(count, itemsSubtotal)`, deux
         arguments. Sans mémoire, chaque clic sur « + » aurait fait CLIGNOTER le
         faux montant de la moyenne avant que la réponse serveur ne le corrige :
         le défaut réapparaissait un dixième de seconde à chaque geste, ce qui
         est exactement le moment où le client regarde. On garde donc le dernier
         prix unitaire CONNU et on le repasse au noyau.
         ⚠️ Il peut être périmé d'un battement — si le client retire justement
           l'article le moins cher, l'optimiste utilise encore son prix. Le
           rendu serveur qui suit corrige dans la même seconde. Une valeur
           d'un battement en retard vaut mieux qu'une moyenne dont on SAIT
           qu'elle est fausse sur un panier mixte sur quatre.

       ⚠️ PAS D'`ecartMax` ICI, ET C'EST DÉLIBÉRÉ. La carte flottante se tait
         au-delà de +2 maillots (« au-delà c'est un mur, pas une marche ») parce
         qu'elle INTERROMPT. Le tiroir, lui, est déjà ouvert par le client : le
         palier à 9 reste demandable, et onix-barre-c.js le dit lui-même —
         « le palier à 9 existe et reste dans l'échelle du tiroir : il paie
         quand un client à 5 monte à 9 ». On passe donc `null`.

       ⚠️ ELLE SE GREFFE SUR renderGauge(), ELLE N'A PAS SON PROPRE CYCLE.
         renderGauge tourne déjà à chaque changement de panier, en optimiste
         comme au rendu serveur. Un second système finirait par afficher un
         palier que le panier ne justifie plus.
       ⚠️ `textContent`, jamais `innerHTML` : rien de ce qui est écrit ici ne
         vient d'un gabarit à balises. Pas d'échappement à oublier. */
    const jaugeEl = document.querySelector('[data-jauge-b]');
    const jaugeArc = jaugeEl && jaugeEl.querySelector('[data-jauge-b-arc]');
    const jaugeCompte = jaugeEl && jaugeEl.querySelector('[data-jauge-b-compte]');
    const jaugeIntro = jaugeEl && jaugeEl.querySelector('[data-jauge-b-intro]');
    const jaugeMontant = jaugeEl && jaugeEl.querySelector('[data-jauge-b-montant]');
    const jaugeSuffixe = jaugeEl && jaugeEl.querySelector('[data-jauge-b-suffixe]');

    let _uniteMemo = null;   /* dernier prix unitaire le plus bas CONNU du panier */
    let _noyauCrie = false;  /* on ne hurle qu'une fois dans la console */

    /* ⛔ LA VOIR AVANT DE LA BRANCHER — sa demande du 05/09, 15h58 : « je
       pourrais la voir avant de la brancher, ce serait le minimum non ? ».
       La jauge ne s'affiche qu'avec un panier : sur un lien nu, panier vide,
       elle reste à hauteur 0 — et le garde `montrer.js` REFUSE de donner un
       lien qui ne montre rien. Mesuré le 05/09 : « [data-jauge-b] est présent
       mais de hauteur 0. Ne pas le donner ».
       ➜ `?voir-jauge=3` joue un panier de 3 maillots au prix d'entrée. C'est un
         paramètre d'URL : aucun visiteur ne l'a jamais.
       ⚠️ IL PASSE PAR LE MÊME CHEMIN DE CALCUL QUE LA PRODUCTION — il ne fait
         que remplacer les trois nombres d'entrée, en tête de `renderJaugeB`.
         Un aperçu qui court-circuite le calcul montre une jauge qui n'existe
         pas ; c'est la leçon de `?voir-carte=N`, écrite dans
         onix-design-b-carte.js.
       ⚠️ Le prix d'entrée est LU sur la carte quand elle est là (une seule
         source, son réglage de section), et vaut 24,99 € sinon — c'est le prix
         d'entrée de la boutique, décision non rouvrable de CLAUDE.md. */
    const _apercuJauge = (function () {
      try {
        const v = new URLSearchParams(location.search).get('voir-jauge');
        if (v === null) return null;
        const carteEl = document.getElementById('onix-carte-b');
        const prix = (carteEl && parseInt(carteEl.getAttribute('data-prix-reference'), 10)) || 2499;
        return { count: Math.max(1, parseInt(v, 10) || 3), prix: prix };
      } catch (e) { return null; }
    })();

    function renderJaugeB(count, baseCents, uniteCents) {
      if (!jaugeEl || !tiers.length) return;
      if (_apercuJauge) {
        count = _apercuJauge.count;
        baseCents = count * _apercuJauge.prix;
        uniteCents = _apercuJauge.prix;
      }

      /* ⛔ SANS LES DEUX NOYAUX, LA JAUGE SE TAIT — elle ne devine pas un
         montant. Même règle que la carte : « une carte qui devine un montant
         est pire qu'une carte absente ». Le message dit quoi faire, une fois. */
      const noyau = window.OnixBarreC;
      const carte = window.OnixCarteB;
      if (!noyau || !noyau.prixMarginalCentimes || !carte || !carte.forme) {
        jaugeEl.hidden = true;
        if (!_noyauCrie) {
          _noyauCrie = true;
          try {
            console.error('[onix-jauge-b] window.OnixBarreC et/ou window.OnixCarteB sont absents : '
              + 'la jauge du tiroir reste masquée. layout/theme.liquid doit charger '
              + 'onix-barre-c.js PUIS onix-design-b-carte.js AVANT '
              + 'cart-drawer-promo-suggest.js, les trois en defer. Aucune formule '
              + 'n’est recopiée dans le tiroir, et ça ne changera pas.');
          } catch (e) {}
        }
        return;
      }

      if (count <= 0) { jaugeEl.hidden = true; return; }

      if (uniteCents > 0) _uniteMemo = uniteCents;
      const unite = (uniteCents > 0) ? uniteCents : _uniteMemo;

      const f = carte.forme(noyau, tiers, count, null);
      const frac = carte.fraction(noyau, tiers, count, null);

      jaugeEl.classList.toggle('onix-jauge-b--acquis', f === 'acquis');
      jaugeEl.classList.toggle('onix-jauge-b--cible', f === 'cible');

      if (jaugeCompte) jaugeCompte.textContent = String(count);

      /* La circonférence est RECALCULÉE depuis le rayon lu dans le SVG, jamais
         écrite en dur : si le rayon change dans le Liquid, l'arc suit. */
      if (jaugeArc) {
        const r = parseFloat(jaugeArc.getAttribute('r')) || 19;
        const circ = 2 * Math.PI * r;
        jaugeArc.style.strokeDasharray = circ.toFixed(2);
        jaugeArc.style.strokeDashoffset = (circ * (1 - Math.max(0, Math.min(1, frac)))).toFixed(2);
      }

      let bloc;
      if (f === 'marche') {
        const suiv = noyau.marcheSuivante(tiers, count);
        const manque = suiv.qty - count;
        const marginal = noyau.prixMarginalCentimes(tiers, count, baseCents, SHOP_RATE, unite);
        /* `null` = plus de marche. On ne remplit pas le trou avec un zéro. */
        if (marginal == null) { jaugeEl.hidden = true; return; }
        const gabarit = String(progStr.remaining)
          .replace('{{n}}', String(manque))
          .replace('{{item}}', manque > 1 ? progStr.itemPlural : progStr.item);
        bloc = carte.composer(gabarit, fmtMoney(marginal), '{{price}}');
      } else {
        const atteint = noyau.palierAtteint(tiers, count);
        const gain = atteint ? noyau.gainCentimes(atteint, baseCents || 0, SHOP_RATE) : 0;
        bloc = carte.composer(String(progStr.savings), fmtMoney(gain), '{{amount}}');
      }

      if (jaugeIntro) jaugeIntro.textContent = bloc.intro;
      if (jaugeMontant) jaugeMontant.textContent = bloc.montant;
      if (jaugeSuffixe) jaugeSuffixe.textContent = bloc.suffixe;
      jaugeEl.hidden = false;
    }

    /* Rendu pur de la jauge à partir d'un COMPTE + d'un SOUS-TOTAL non-bundle
       (cents). Aucune lecture réseau → utilisable en optimiste instantané
       depuis cart-drawer.js (window.__onixPromoGauge) comme en serveur. */
    /* Le panier vu par la dernière jauge. Sert à convertir le palier en
       EUROS pour la bande — même source que l'échelle, jamais un second
       calcul : deux calculs finissent par diverger d'un centime. */
    let _jaugeCount = 0, _jaugeBase = 0;

    function renderGauge(count, baseCents, uniteCents) {
      _jaugeCount = count; _jaugeBase = baseCents;
      renderJaugeB(count, baseCents, uniteCents);

      /* ⛔ CE QUI ÉTAIT ICI ÉTAIT MORT DEPUIS LE 18/08, ET C'ÉTAIT UNE SECONDE
         FORMULE POUR LE MÊME EURO — retiré le 05/09, trouvé par le banc
         `banc-jauge-tiroir.js` et pas par ma relecture.
         Le bandeau `#onix-cart-progress` a été VIDÉ le 18/08 : il ne porte plus
         ni `-msg`, ni `-savings`, ni `-fill`, et son CSS pose `display: none`.
         `progMsg`, `progSav` et `progFill` valaient donc `null` — mais les
         cinquante lignes qui les alimentaient étaient restées, dont un calcul
         complet du prix marginal (`nextTotal - curTotal`) écrit à la main.
         Deux dangers, tous deux silencieux :
           · elle ne passait PAS par le noyau, donc elle ne connaissait pas le
             correctif du panier mixte du 05/09 — elle retombait sur la moyenne
             `base / count`, celle qui annonçait 29,74 € pour un maillot à
             24,99 €. Rebrancher `#onix-cart-progress-msg` aurait ressuscité le
             défaut, corrigé partout ailleurs ;
           · deux formules pour la même chose divergent d'un centime, et c'est
             écrit noir sur blanc dans onix-barre-c.js.
         Ce qui RESTE du bandeau : ses attributs `data-t-*`, lus une fois au
         démarrage (`progStr`) et utilisés par la jauge. Ils vivent sur un
         élément non affiché — `dataset` se lit très bien sur `display: none`.
         ⚠️ On garde le `hidden` du conteneur : d'autres scripts peuvent le lire,
           et ça ne coûte rien. */
      if (progEl) progEl.hidden = count <= 0;
    }

    /* Variante serveur : calcule le sous-total non-bundle depuis le cart.
       ⚠️ IGNORÉE tant qu'une écriture panier est en vol. Sans ce garde-fou, un
       clic sur +/− produisait un VA-ET-VIENT de la barre : la jauge optimiste
       montait tout de suite (2 → 3), puis une réponse serveur encore basée sur
       l'état d'AVANT la redescendait, puis la réponse finale la remontait —
       « elle monte, descend et remonte ». Pendant une écriture, l'optimiste
       fait foi ; le serveur ne réconcilie qu'une fois le panier stabilisé. */
    function updateProgress(count, cart) {
      const dr = document.querySelector('[data-cart-drawer-root]');
      if (dr && dr.classList.contains('onix-cart-drawer--writing')) return;
      const base = (cart.items || []).reduce((s, i) => {
        const isB = i.properties && i.properties._offer_bundle === 'true';
        return s + (isB ? 0 : (i.final_line_price || i.line_price || 0));
      }, 0);
      renderGauge(count, base, uniteMinPanier(cart.items));
    }

    /* Exposé pour la mise à jour OPTIMISTE instantanée de la jauge par le
       drawer (cart-drawer.js) lors d'un changement de quantité, sans attendre
       le re-fetch serveur. */
    window.__onixPromoGauge = renderGauge;

    /* ─── APPLIQUER LE PALIER ATTEINT, SUR DEMANDE D'UN AUTRE BLOC ────────
       Ce module PROPOSE les codes de palier — le client clique, il applique.
       L'offre « 2e maillot » a besoin de l'inverse : elle annonce un prix DÉJÀ
       remisé (17,50 €, soit 4998 − 749 − 2499), donc la remise doit être posée
       sans un second geste, sinon le prix affiché est une promesse non tenue.

       ⚠️ ELLE PASSE PAR ICI ET PAS AILLEURS. Poser `/discount/onixN` depuis un
       autre fichier met deux modules sur la même session : `setSessionDiscount`
       efface (`discount=`) avant de reposer, et cet effacement tombait sur
       l'écriture du voisin. Mesuré le 23/08 — l'article ajouté disparaissait,
       sans erreur ni trace, une exécution sur trois. Un code de session a UN
       propriétaire ; les autres lui demandent.

       `_autoApplying` évite que notre propre écriture soit relue comme une
       action du client par la boucle de réconciliation. */
    window.__onixAppliquerPalier = async function (cart) {
      try {
        const c = cart || (await (await fetch(LROOT + 'cart.js', { headers: { Accept: 'application/json' } })).json());
        if ((c.cart_level_discount_applications || []).length) return false;  /* une remise tient déjà */
        const dejaTier = findOurAppliedTier(c);
        if (dejaTier) return false;
        /* Le compte du palier est celui des maillots HORS bundle — même règle
           que le compteur affiché, sinon on poserait un palier que la jauge ne
           montre pas. */
        const n = (c.items || []).reduce(function (t, i) {
          var estBundle = i.properties && i.properties._offer_bundle === 'true';
          return estBundle ? t : t + i.quantity;
        }, 0);
        const atteint = findReachedTier(n);
        if (!atteint) return false;
        _autoApplying = true;
        try { await setSessionDiscount([atteint.code]); } finally { _autoApplying = false; }
        return atteint.code;
      } catch (e) { return false; }
    };

    let _currentTier = null;
    let _refreshing = false;
    let _autoApplying = false;
    let _applying = false;
    let _refreshTimer = null;
    let _lastCount = -1;
    /* Tentatives d'auto-application du code réclamé au popup. Borné : si le
       code est refusé côté Shopify (expiré, désactivé), on n'entre pas dans
       une boucle apply → refresh → apply à chaque changement de panier. */
    let _claimedTries = 0;
    /* Anti-spam : on n'applique un code QUE si le compteur panier est resté
       stable pendant ce délai (le temps qu'un spam de +/- et les
       /cart/change.js en vol se calment). L'affichage, lui, reste instantané. */
    const SETTLE_MS = 350;

    function show(tier) {
      /* Non-cumul : un code roue encore valide prime — on ne propose pas le
         palier par-dessus (le client saisit son code roue). Voir
         wheelCodeActive() pour le détail de la règle d'expiration. */
      if (wheelCodeActive()) { hide(); return; }
      /* Code réclamé au popup newsletter : inutile de le proposer ici, il
         s'applique TOUT SEUL au palier (voir l'auto-apply dans doRefresh).
         On ne masque que CE palier : si le client monte à un palier supérieur
         (meilleure remise), on le lui propose — sinon il y perdrait. */
      const claimed = readPopupTier();
      if (claimed && claimed.code.toUpperCase() === tier.code.toUpperCase()) { hide(); return; }
      _currentTier = tier;
      /* ⚠️ LE MONTANT EN EUROS, PAS LE LIBELLÉ. Le bloc disait « -15 % »
         quand l'échelle, dix pixels plus haut, dit « -7,49 € » depuis le
         18/08 : deux unités pour la même remise dans le même tiroir.
         Repli sur le libellé si la jauge n'a pas encore tourné — mieux vaut
         « -15 % » que « -0,00 € ». */
      if (msgEl) {
        const unite = _jaugeCount > 0 ? (_jaugeBase || 0) / _jaugeCount : 0;
        const gain = unite > 0 ? gainEnCentimes(tier, unite) : 0;
        msgEl.textContent = gain > 0 ? '-' + fmtMoney(gain) : tier.label;
      }
      root.hidden = false;
      root.classList.add('is-visible');
      if (applyBtn) applyBtn.disabled = false;
      if (verbeEl) verbeEl.textContent = applyTxt;
    }

    function hide() {
      _currentTier = null;
      root.hidden = true;
      root.classList.remove('is-visible');
    }

    /* Server-side: replace the session discount with the given codes.
       Pass an array of codes (or null/empty for "clear all"). We clear
       first because Shopify's /discount/CODE keeps the bigger discount
       on collisions, which would block downgrades.

       Stacking pattern : Shopify's /discount endpoint takes ONE code
       per call. Comma-separated (`/discount/A,B`) is treated as a
       single literal code "A,B" and rejected as invalid. To stack we
       call /discount/CODE_N sequentially — Shopify keeps any code
       whose combinesWith config allows stacking with the codes
       already in the session, and replaces the rest. The per-code
       combinesWith config (set in the Shopify admin) decides which
       codes survive. */
    async function setSessionDiscount(codes) {
      await loggedFetch(LROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'discount='
      });
      const list = Array.isArray(codes)
        ? codes.filter(Boolean)
        : (codes ? [codes] : []);
      for (const code of list) {
        await loggedFetch(LROOT + 'discount/' + encodeURIComponent(code));
      }
    }

    /* Codes possibles de l'offre découverte (bundle) — codes RENOMMÉS en
       illisible (2026-06-19) pour qu'ils ne soient pas réutilisables s'ils
       sont vus au checkout. EUR (prix fixe) : A7X2K9MQ (2) / B8Z3P4WH (4).
       Autres devises (-40%) : C5W2J8NK (2) / D8K4H2NV (4). Sert à détecter/
       effacer un code offre appliqué à tort. */
    const OFFER_CODES = ['A7X2K9MQ', 'B8Z3P4WH', 'C5W2J8NK', 'D8K4H2NV'];

    /* Quel code offre DOIT être appliqué pour ce panier — ou null.
       Règle « pas moins pas plus » : le code n'est valide QUE si le nombre
       d'articles bundle est EXACTEMENT un palier (2 → oniix, 4 → onm). 1, 3,
       5… → null (aucune remise offre).
       On gate sur le COMPTE (toujours présent dans le panier), PAS sur les
       propriétés _offer_code/_offer_qty : celles-ci peuvent manquer (panier
       legacy, ou header servi en cache sans les propriétés) → le compte reste
       la source fiable. Le code explicite (_offer_code) ou le global popup
       priment s'ils sont valides, sinon on déduit du palier. */
    function offerCodeToApply(cart) {
      const items = (cart.items || []).filter(i => i.properties && i.properties._offer_bundle === 'true');
      if (!items.length) return null;
      const qty = items.reduce((s, i) => s + (i.quantity || 0), 0);
      if (qty !== 2 && qty !== 4) return null;
      /* Code = compte (2/4) + DEVISE active : EUR → prix fixe (oniix/onm),
         autres → -40% (oniix-int/onm-int). Dérivé du compte+devise (toujours
         dispo), pas des propriétés (robuste reload + changement de devise). */
      const isEUR = ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR') === 'EUR';
      if (qty === 4) return isEUR ? 'B8Z3P4WH' : 'D8K4H2NV';
      return isEUR ? 'A7X2K9MQ' : 'C5W2J8NK';
    }

    /* ── Affichage pur (jauge #3/#5 + popup palier), zéro réseau ───────
       Recalcule le compte non-bundle puis met à jour la barre de
       progression et décide d'afficher ou non le popup. Ne touche JAMAIS
       aux codes (l'application reste le job de doRefresh). Appelée en
       synchrone dès qu'un cart est connu → rendu instantané. */
    function renderDisplay(cart) {
      /* ⚠️ `_tierPose` EST PARTI AVEC L'ÉCHELLE — 05/09. Il ne servait qu'à la
         coche « appliqué » posée sur la marche atteinte ; la jauge du design B
         n'a pas de coche « appliqué » (c'est la bande cyan, juste dessous, qui
         dit ce qui est acquis et combien). `findOurAppliedTier` reste utilisé
         par la rétrogradation automatique, plus bas — c'est lui la vraie
         source, pas cette variable. */
      if (!cart || !cart.items) return;
      const bundleQty = (cart.items || []).reduce((s, i) => {
        const isB = i.properties && i.properties._offer_bundle === 'true';
        return s + (isB ? (i.quantity || 0) : 0);
      }, 0);
      const count = Math.max(0, (cart.item_count || 0) - bundleQty);

      updateProgress(count, cart);

      const appliedTier = findOurAppliedTier(cart);
      const reached = findReachedTier(count);

      if (!reached) { hide(); return; }
      /* Déjà sur le palier atteint → rien à proposer. */
      if (appliedTier && appliedTier.qty === reached.qty) { hide(); return; }
      /* Code de palier périmé (palier tombé sous son seuil) → pas de popup le
         temps que doRefresh le SUPPRIME ; le palier réellement atteint sera
         proposé au refresh suivant. */
      if (appliedTier && appliedTier.qty > reached.qty) { hide(); return; }
      /* Aucun code de palier, OU un code de palier INFÉRIEUR est posé →
         on PROPOSE le palier atteint. Le client décide d'appliquer : jamais
         d'application ni de bascule automatique. */
      show(reached);
    }

    /* Entry point. Si l'event embarque le cart déjà rendu par le drawer,
       on affiche la jauge + le popup INSTANTANÉMENT (synchrone, zéro
       fetch, zéro attente). Le debounce ne sert plus qu'à coalescer
       l'application asynchrone des codes (auto-apply / clear / upgrade)
       faite dans doRefresh — invisible pour l'utilisateur. */
    function refresh(e) {
      /* Affichage immédiat (jauge/popup) à CHAQUE event qui porte le cart. */
      if (e && e.detail && e.detail.cart) {
        try {
          renderDisplay(e.detail.cart);
          /* Suppression INSTANTANÉE d'un code de palier devenu invalide,
             directement sur le cart FRAIS fourni par le drawer — sans attendre
             le re-fetch /cart.js de doRefresh, qui a un lag de cache après une
             mutation et faisait traîner la suppression plusieurs secondes. */
          removeInvalidTier(e.detail.cart);
        } catch (_) {}
      }
      /* On NE reprogramme PAS si un doRefresh est déjà en attente : une rafale
         de cart:refresh (re-dispatch en cascade cart-drawer ↔ promo-suggest)
         repousserait sinon doRefresh indéfiniment (< 150ms à chaque event) et
         les codes prendraient un cran de retard. Le doRefresh déjà programmé
         lira de toute façon l'état le plus récent du panier. */
      /* ⚠️ ON RETIENT LA DEMANDE AU LIEU DE LA JETER — 18/08.
         Le commentaire ci-dessus a raison sur le fond : reprogrammer à chaque
         événement repousserait doRefresh indéfiniment. Mais « le doRefresh déjà
         programmé lira l'état le plus récent » n'est vrai que s'il lit APRÈS le
         dernier changement. Après un clic sur « + », il lit AVANT : le panier
         serveur n'a pas encore la nouvelle quantité, il conclut qu'il n'y a rien
         à faire, et la montée de palier n'a jamais lieu. Mesuré : `onix4` figé à
         4 maillots, 79,97 € au lieu de 75,96 €, soit 4,01 € pour le client — et
         un `cart:refresh` à la main corrigeait tout en 2 s, donc c'était bien le
         rendez-vous qui manquait, pas la logique.
       ➜ Le rejeu a été TENTÉ puis ABANDONNÉ (mesuré : « la montée part une
         fois sur deux », voir le grand commentaire PAS d'AUTO-UPGRADE plus
         bas) : la demande est sciemment jetée, le doRefresh déjà programmé
         relira le panier, et le POPUP est le chemin normal de montée de
         palier. Ne pas réintroduire un drapeau de rejeu ici. */
      if (_refreshTimer) return;
      _refreshTimer = setTimeout(doRefresh, 150);
    }

    /* Suppression INSTANTANÉE d'un code de palier devenu invalide, calculée
       sur le cart FRAIS fourni par le drawer (zéro re-fetch). Ne touche QU'au
       code de palier ; préserve le code offre (bundle). doRefresh reste le
       filet de sécurité (réconciliation serveur). */
    async function removeInvalidTier(cart) {
      if (!cart || !cart.items || _autoApplying || _applying) return;
      const bundleQty = cart.items.reduce((s, i) => {
        const isB = i.properties && i.properties._offer_bundle === 'true';
        return s + (isB ? (i.quantity || 0) : 0);
      }, 0);
      const count = Math.max(0, (cart.item_count || 0) - bundleQty);
      const appliedTier = findOurAppliedTier(cart);
      if (appliedTier && count < appliedTier.qty) {
        _autoApplying = true;
        try {
          const desiredBundle = offerCodeToApply(cart);
          await setSessionDiscount(desiredBundle ? [desiredBundle] : []);
        } catch (_) {}
        _autoApplying = false;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    }

    /* Read all currently-applied discount titles from a cart payload.
       Aggregates cart-level + line-level + session codes — Shopify
       returns them in three different shapes depending on whether the
       discount is "applying" or just "in the session and waiting for
       conditions to be met". We treat all three as "the cart has this
       code right now" so auto-clear / auto-apply doesn't fight itself. */
    function readAppliedCodes(cart) {
      const set = new Set();
      const add = (s) => { if (s) set.add(String(s).toUpperCase()); };
      (cart.cart_level_discount_applications || []).forEach((a) => add(a.title));
      (cart.items || []).forEach((i) => {
        (i.discounts || []).forEach((d) => add(d.title));
        (i.line_level_discount_allocations || []).forEach((a) => {
          if (a.discount_application) add(a.discount_application.title);
        });
      });
      (cart.discount_codes || []).forEach((d) => add(d.code));
      return set;
    }

    async function doRefresh() {
      /* Le timer a tiré : on le libère AUSSITÔT pour que refresh() puisse en
         reprogrammer un au prochain changement (sinon, avec le guard
         `if (_refreshTimer) return`, plus aucun refresh ne passerait). */
      _refreshTimer = null;
      if (_refreshing || _autoApplying || _applying) {
        /* Something's in flight — retry shortly to pick up the settled state */
        _refreshTimer = setTimeout(doRefresh, 300);
        return;
      }
      _refreshing = true;
      try {
        const cart = await loggedFetch(LROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());

        const desiredBundle = offerCodeToApply(cart); // 'ONIIX'/'ONM' ou null (gate compte exact)
        const applied = readAppliedCodes(cart);
        const appliedOffer = OFFER_CODES.filter(c => applied.has(c)); // code(s) offre actuellement posé(s)

        /* AFFICHAGE d'abord, toujours : la jauge + le popup reflètent l'état
           courant à chaque lecture (instantané, zéro effet de bord). */
        renderDisplay(cart);

        /* SETTLING anti-spam : on ne TOUCHE PAS aux codes tant que le panier
           n'est pas stable. Si le compteur a bougé depuis la dernière lecture
           (spam +/- ou /cart/change.js encore en vol), on re-vérifie dans
           SETTLE_MS au lieu d'appliquer un code qui serait périmé une fraction
           de seconde plus tard. Tue la cascade clear→apply (clignotement). */
        const itemCount = cart.item_count || 0;
        if (itemCount !== _lastCount) {
          _lastCount = itemCount;
          clearTimeout(_refreshTimer);
          _refreshTimer = setTimeout(doRefresh, SETTLE_MS);
          return;
        }

        /* AUTO-APPLY le bon code offre QUAND le bundle est au compte EXACT
           (desiredBundle non null) et qu'il n'est pas déjà seul appliqué.
           On déclenche aussi si un AUTRE code offre est posé à tort (ex:
           oniix figé sur un 4-pack) pour le remplacer par le bon. Sans ça,
           le client voit un « prix bundle » cosmétique mais Shopify facture
           plein pot au checkout (le popup ne pose pas le code lui-même). */
        if (desiredBundle && (!applied.has(desiredBundle) || appliedOffer.some(c => c !== desiredBundle))) {
          _autoApplying = true;
          try {
            const tier = findOurAppliedTier(cart);
            const codes = tier ? [desiredBundle, tier.code] : [desiredBundle];
            await setSessionDiscount(codes);
          } catch (_) {}
          _autoApplying = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        /* AUTO-CLEAR : aucun bundle au compte exact (0, 3, 5… maillots) mais
           un code offre est encore posé → on l'efface (« pas moins pas plus »).
           Préserve le code de palier (onixN) s'il y en a un. */
        if (!desiredBundle && appliedOffer.length) {
          _autoApplying = true;
          try {
            const tier = findOurAppliedTier(cart);
            await setSessionDiscount(tier ? [tier.code] : []);
          } catch (_) {}
          _autoApplying = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        /* Tier counter — counts NON-BUNDLE maillots only.
           Bundle items (those added via the OFFRE popup, marked with
           `_offer_bundle:true`) are part of their own discount (oniix)
           and the merchant doesn't want them to also count toward the
           tier-popup thresholds. So a customer who buys "2 maillots
           offre découverte + 3 maillots classiques" sees the tier
           popup based on 3, not 5.
           The popup itself is still SHOWN when the bundle is present
           (so the customer can stack oniix + a tier code) — it's only
           the threshold counter that excludes bundle items. */
        const bundleQty = (cart.items || []).reduce((s, i) => {
          const isB = i.properties && i.properties._offer_bundle === 'true';
          return s + (isB ? (i.quantity || 0) : 0);
        }, 0);
        const count = Math.max(0, (cart.item_count || 0) - bundleQty);

        const appliedTier = findOurAppliedTier(cart);
        const reached = findReachedTier(count);

        /* SUPPRESSION (retrait d'article) : le code de palier appliqué n'est
           plus valide — la quantité est tombée sous son seuil. On SUPPRIME le
           code de palier ; AUCUNE bascule automatique vers un autre code. Le
           popup reproposera ensuite le palier réellement atteint, à appliquer
           manuellement par le client. On préserve uniquement le code offre
           (bundle), géré séparément plus haut. */
        if (appliedTier && count < appliedTier.qty) {
          _autoApplying = true;
          try {
            await setSessionDiscount(desiredBundle ? [desiredBundle] : []);
          } catch (_) {}
          _autoApplying = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        /* AUTO-APPLY du code RÉCLAMÉ au popup newsletter. Le client a cliqué
           « Appliquer » sur son code avant d'avoir le bon nombre de maillots :
           dès qu'il atteint le seuil, on pose le code pour lui. C'est la seule
           application automatique d'un code de palier — elle est légitime
           parce que le client l'a explicitement demandée au popup.
           On n'écrase jamais un palier déjà posé qui serait MEILLEUR. */
        const claimed = readPopupTier();
        if (claimed && count >= claimed.qty && !applied.has(claimed.code.toUpperCase())
            && (!appliedTier || appliedTier.qty <= claimed.qty)
            && !wheelCodeActive()   /* ne JAMAIS écraser un code roue encore valide */
            && _claimedTries < 3) {
          _claimedTries++;
          _autoApplying = true;
          try {
            await setSessionDiscount(desiredBundle ? [desiredBundle, claimed.code] : [claimed.code]);
          } catch (_) {}
          _autoApplying = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        /* Le code réclamé est posé (ou plus atteignable) → on réarme le compteur
           pour le prochain cycle (panier vidé puis re-rempli). */
        if (!claimed || applied.has(claimed.code.toUpperCase()) || count < claimed.qty) _claimedTries = 0;

        /* ⚠️ PAS D'AUTO-APPLICATION DU PALIER — ESSAYÉE ET RETIRÉE LE 18/08.
           Sa demande était juste : faire cliquer quelqu'un pour une remise
           qu'il a déjà gagnée n'a pas de sens. Mais l'automatisme s'est révélé
           INFIABLE sur le chemin des changements de quantité, et infiable ici
           veut dire que LE CLIENT PAIE PLUS.

           Trois tentatives, trois échecs, tous mesurés :
             · appliquer depuis doRefresh → `/cart.js` a un décalage de cache
               après une mutation (c'est déjà la raison d'être de
               removeInvalidTier). Il relit 3 maillots quand il y en a 4,
               conclut que `onix4` suffit, et s'arrête.
             · retenir la demande au lieu de la jeter dans `refresh()` → la
               montée part une fois sur deux.
             · décider sur le panier frais `e.detail.cart` → mieux, mais en
               REDESCENDANT de 5 à 4 le code est retiré par removeInvalidTier
               et jamais reposé : 99,96 € au lieu de 75,96 €, 24 € de trop.

           ➜ Le popup redevient le chemin normal. Il n'est pas élégant, il
             demande un clic — mais il donne le BON prix. Un automatisme qui
             fait payer plus est pire qu'un bouton qu'on trouve moche.
           ➜ Pour reprendre le sujet : le vrai obstacle est la coordination
             entre removeInvalidTier (qui efface) et une éventuelle repose. Les
             deux doivent être UNE seule décision prise sur UN seul panier, pas
             deux fonctions qui se croisent. */

        /* PAS d'AUTO-UPGRADE : si le client atteint un palier SUPÉRIEUR alors
           qu'un code de palier inférieur est déjà posé, on NE bascule PAS tout
           seul. Le popup (renderDisplay) propose le palier atteint ; le client
           applique s'il le souhaite. (Affichage déjà fait en tête de doRefresh
           via renderDisplay.) */
      } catch (e) {
        console.warn('[onix-promo-suggest] refresh failed', e);
      } finally {
        _refreshing = false;
      }
    }

    /* Click Apply: stack the suggested tier with the bundle code if a
       bundle is currently in the cart (so the merchant gets oniix +
       onix3/4/etc together at checkout), otherwise just apply the tier.
       setSessionDiscount() clears first, so it works for both first-
       time apply (no code yet) and upgrade (replacing a previous tier). */
    async function applySuggested() {
      if (!_currentTier || _applying) return;
      _applying = true;
      const tier = _currentTier;

      if (applyBtn) applyBtn.disabled = true;
      if (verbeEl) verbeEl.textContent = '…';

      try {
        /* Read the cart once to find out whether the bundle is still
           present. If it is, we apply ['oniix', tier_code] so both
           stack at checkout. Otherwise just the tier code. */
        const preCart = await loggedFetch(LROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        const desiredBundle = offerCodeToApply(preCart); // bundle au compte exact uniquement
        const codes = desiredBundle ? [desiredBundle, tier.code] : [tier.code];
        await setSessionDiscount(codes);

        /* Verify the tier code actually applied (Shopify's /discount
           endpoint always 302s, even for invalid codes). */
        const verifyCart = await loggedFetch(LROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        const titles = [];
        (verifyCart.cart_level_discount_applications || []).forEach(a => { if (a.title) titles.push(a.title.toUpperCase()); });
        (verifyCart.items || []).forEach(i => (i.discounts || []).forEach(d => { if (d.title) titles.push(d.title.toUpperCase()); }));
        /* Only count session codes Shopify marks applicable, so a stale
           inapplicable session code doesn't fool the verify into
           "applied" when Shopify actually didn't honour it. */
        (verifyCart.discount_codes || []).forEach((d) => {
          if (d.code && d.applicable) titles.push(d.code.toUpperCase());
        });

        if (titles.includes(tier.code.toUpperCase())) {
          hide();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          /* Apply silently failed — restore the popup so user can retry
             or use the manual input. */
          console.warn('[onix-promo-suggest] /discount/' + tier.code + ' did not apply server-side');
          if (applyBtn) applyBtn.disabled = false;
          if (verbeEl) verbeEl.textContent = applyTxt;
        }
      } catch (e) {
        console.warn('[onix-promo-suggest] apply failed', e);
        if (applyBtn) applyBtn.disabled = false;
        if (verbeEl) verbeEl.textContent = applyTxt;
      } finally {
        _applying = false;
      }
    }

    if (applyBtn) applyBtn.addEventListener('click', applySuggested);

    /* React to every cart change. */
    document.addEventListener('cart:refresh', refresh);

    /* Watch the cart count badge for instant detection (same pattern
       as the discount bar — fires reliably across all change paths). */
    const countNode = document.querySelector('[data-cart-count]');
    if (countNode) {
      let prev = countNode.textContent.trim();
      new MutationObserver(() => {
        const cur = countNode.textContent.trim();
        if (cur !== prev) {
          prev = cur;
          refresh();
        }
      }).observe(countNode, { childList: true, characterData: true, subtree: true });
    }

    /* Initial render */
    refresh();

    /* Mobile bfcache : la page restaurée n'exécute pas les scripts. On force
       un refresh pour que le popup se remette à jour avec le cart courant.
       Sans ça, l'utilisateur doit recharger la page pour voir la promo. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh();
    });

    /* Re-sync quand la page redevient visible (switch tab, retour app). */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
